import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ACTIONS } from '../game/gameConfig';

const SEQUENCE = ['left', 'right', 'center'];
const TARGET_POSITIONS = {
  left: '25%',
  center: '50%',
  right: '75%',
};

function TutorialScreen({ onComplete }) {
  const [step, setStep] = useState(0);
  const [message, setMessage] = useState('先化解左路攻擊');
  const currentAction = SEQUENCE[step];

  const handleAction = (action) => {
    if (action !== currentAction) {
      setMessage(`試試「${ACTIONS[currentAction].label}」`);
      return;
    }

    const nextStep = step + 1;
    if (nextStep >= SEQUENCE.length) {
      onComplete();
      return;
    }

    setStep(nextStep);
    setMessage(
      nextStep === 1
        ? '很好，現在化解右路攻擊'
        : '中線已開，用日字衝拳反擊',
    );
  };

  return (
    <motion.main className="screen-panel" initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
      <div className="section-heading">
        <span className="eyebrow">入門 · 基本架式</span>
        <h2>直接點按亮起位置</h2>
        <p>{message}</p>
      </div>

      <div className="tutorial-stage">
        <div className="tutorial-line" />
        <motion.button
          className={`tutorial-target target-${currentAction}`}
          key={step}
          type="button"
          style={{
            left: TARGET_POSITIONS[currentAction],
            marginLeft: '-52px',
            position: 'absolute',
          }}
          onClick={() => handleAction(currentAction)}
          initial={{ scale: 0.7, opacity: 0 }}
          animate={{ scale: [1, 1.08, 1], opacity: 1 }}
          transition={{ scale: { repeat: Infinity, duration: 1 } }}
          whileTap={{ scale: 0.88 }}
          aria-label={`點按${ACTIONS[currentAction].label}`}
        >
          {ACTIONS[currentAction].shortLabel}
        </motion.button>
        <span className="step-counter">{step + 1} / 3</span>
      </div>
    </motion.main>
  );
}

export default TutorialScreen;